import { render, staticRenderFns } from "./GeneralPopup.vue?vue&type=template&id=f1fe9e0a&scoped=true&"
import script from "./GeneralPopup.vue?vue&type=script&lang=js&"
export * from "./GeneralPopup.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPopup.vue?vue&type=style&index=0&id=f1fe9e0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fe9e0a",
  null
  
)

export default component.exports